import React, { useCallback } from "react";
import {
  IModifiersObjects,
  IRequiredModifier,
} from "../../../../models/try2Combo";
import HorizentalSlider from "./sliders/HorizentalSlider";
import VerticalSlider from "./sliders/VerticalSlider";
import styleClasses from "../../try2.module.scss";
import { Container } from "react-bootstrap";
import ApplyButton from "./ApplyButton";
import { REQUIRED_MODIFIERS } from "../../../../constants";
import { itemBuckets } from "../../../../priceCalculation/buckets";
import { delayer } from "../../../../components/utils";
import * as CONSTANT from "../../../../constants";
import UpSellModifierGroup from "../../../../components/OrderAnItem/ItemCustomization/UpSellModifierGroup/UpSellModifierGroup";
import { ADDITIONAL_ADDED, ADDITIONAL_REMOVED, BY_DEFAULT_ADDED, BY_DEFAULT_ADDED_V2 } from "../../../../priceCalculation/constants";
import { compareTwoStates } from "../../../../helpers/helperMethods";

const APPLY = "Apply";
const NO_THANKS = "No Thanks";
const proteinGroup = JSON.parse(CONSTANT.REACT_APP_PROTEIN_GROUPS);

const Sliders: React.FC<IRequiredModifier> = (props) => {
  const {
    setOtherDressingData,
    otherDressingHandler,
    items_required_modifier_groups,
    selectedIngredients,
    handleIngredientSelection,
    isInItemPresent,
    setIsInItemPresent,
    sectionSelected,
    selectedAddedIngredients,
    noDressingHandler,
    isNoDressing,
    noDressingModifiers,
    addItemtoCombo,
    selectedOtherDressingData,
    label,
    selectedItem,
    showProteinModalOnCombo,
    isSaladFirstSelection,
    try2comboUpsellStyles,
    isShowingRequiredModalOnCustomization,
    isAddOnOrDoubleProtein,
    getOrderButtonState
  } = props;

  const delayerFunction = useCallback(delayer(addItemtoCombo, 100), []);

  const requiredModifierDetail = () => {
    if (
      items_required_modifier_groups &&
      items_required_modifier_groups.length > 0
    ) {
      const { id, name, extendable_limit, max, min, label } =
        items_required_modifier_groups[0];
      return { id, name, extendable_limit, max, min, label };
    }
  };

  const isItSubstitute = () => {
    if (items_required_modifier_groups?.length == 0) return false;
    const { name, extendable_limit, max, min } = requiredModifierDetail();
    if (extendable_limit === 1 && max === 1 && min === 1) {
      return true;
    } else {
      return false;
    }
  };

  const noDressing =
    items_required_modifier_groups?.length == 0
      ? false
      : (function () {
          const { id } = requiredModifierDetail();
          const requiredModifiersBucket = itemBuckets.getSingleBucket({
            name: REQUIRED_MODIFIERS,
            fromItem: parseInt(sectionSelected),
          });
          if (requiredModifiersBucket?.noDressings) {
            const noDressingState = requiredModifiersBucket?.noDressings.find(
              (e) => e.id === id
            );
            return noDressingState.noDressing;
          } else {
            return false;
          }
        })();

  const isApplyDisable = showProteinModalOnCombo
    ? false
    : getOrderButtonState();

  const isShowOtherDreesingCard = () => {
    let isTrue,
      isFalse = false;
    if (
      items_required_modifier_groups &&
      items_required_modifier_groups.length > 0
    ) {
      isTrue =
        items_required_modifier_groups[0]?.required_modifiers_groups_modifiers?.every(
          (modifier) => modifier?.in_item
        );
      isFalse =
        items_required_modifier_groups[0]?.required_modifiers_groups_modifiers?.every(
          (modifier) => !modifier?.in_item
        );
    }
    if (isTrue || isFalse) {
      return false;
    } else {
      return true;
    }
  };

  const handleSelection = (data: any) => {
    handleIngredientSelection(data);
    if (isItSubstitute()) {
      delayerFunction();
    }
  };

  const isProteinSelection = (function () {
    const firstSelection: any = parseInt(sectionSelected) - 1;

    return itemBuckets.getSingleBucketKeyValue({
      name: isAddOnOrDoubleProtein ? CONSTANT.ADD_ONS : CONSTANT.CORE_MODIFIERS,
      fromItem: firstSelection,
      modifierType: ADDITIONAL_ADDED,
      key: CONSTANT.BUCKET_MODIFIERS_KEY,
    });
  })();

  const buttonLabel = () => {
    if(!showProteinModalOnCombo) return APPLY;
    const selectedProtienModifiersLength = isProteinSelection.length;
    const doubleYourProtienModal: HTMLElement = document.getElementById("double-your-protien-modal");
    const addYourProtienModal: HTMLElement = document.getElementById("add-your-protien-modal");
    if(!doubleYourProtienModal && !addYourProtienModal) return APPLY;
    if(doubleYourProtienModal){
      const firstSelection: any = parseInt(sectionSelected) - 1;
      const updatedCoreModifierArray = itemBuckets.getSingleBucket({
        name: CONSTANT.CORE_MODIFIERS,
        fromItem: firstSelection,
        isFromItemComingAsAnIndex: true
      }).modifiers.filter(modifier => proteinGroup.includes(modifier.modifier_group_id));

      const originalCoreModifierArray = itemBuckets.getSingleBucketKeyValue({
        name: CONSTANT.CORE_MODIFIERS,
        fromItem: firstSelection,
        modifierType: BY_DEFAULT_ADDED_V2,
        key: CONSTANT.BUCKET_MODIFIERS_KEY,
      }).filter(modifier => proteinGroup.includes(modifier.modifier_group_id));
      if(!compareTwoStates(updatedCoreModifierArray, originalCoreModifierArray)) return APPLY;
    }
    if(addYourProtienModal && selectedProtienModifiersLength > 0) return APPLY;
    return NO_THANKS;
  }

  return (
    <>
      <div className="">
        {isItSubstitute() ? (
          ""
        ) : (
          <h6 className="text-center text-sm-uppercase font-sm-Cls mb-sm-4 m-0 mb-sm-2 ls-sm-normal">
            {selectedItem?.category_id?.toString() === CONSTANT.REACT_APP_SALADS_ID
              ? " "
              : requiredModifierDetail()?.label}
          </h6>
        )}
        <div
          className={`${styleClasses.Dressing_desktop_view} px-lg-5 px-md-0 Dressing-desktop_view d-none d-md-block other-dressing-view try2_dressing_modal`}
        >
          <Container className="ps-2">
            <h5 className="text-start f-s22 f-sm-s16 pt-2 text-capitalize  mb-2">
              {isItSubstitute()
                ? "choose your bread"
                : isShowOtherDreesingCard() &&
                  selectedItem?.category_id?.toString() === CONSTANT.REACT_APP_SALADS_ID
                ? !showProteinModalOnCombo && "Choose your dressing"
                : "Recommended"}
            </h5>
          </Container>
          {!showProteinModalOnCombo && (
            <HorizentalSlider
              items_required_modifier_groups={items_required_modifier_groups}
              otherDressingHandler={otherDressingHandler}
              selectedIngredients={selectedIngredients}
              handleIngredientSelection={handleSelection}
              setOtherDressingData={setOtherDressingData}
              isInItemPresent={isInItemPresent}
              sectionSelected={sectionSelected}
              selectedAddedIngredients={selectedAddedIngredients}
              noDressingHandler={noDressingHandler}
              isNoDressing={noDressing}
              noDressingModifiers={noDressingModifiers}
              label={label}
            />
          )}
        </div>
        {!showProteinModalOnCombo && (
          <>
            <h5 className="text-start mb-sm-4 f-s22 f-sm-s16 pt-2 text-capitalize mb-2 d-md-none">
              {isItSubstitute()
                ? "choose your bread"
                : isShowOtherDreesingCard() &&
                  selectedItem?.category_id?.toString() === CONSTANT.REACT_APP_SALADS_ID
                ? !showProteinModalOnCombo && "Choose your dressing"
                : "Recommended"}
            </h5>

            <VerticalSlider
              items_required_modifier_groups={items_required_modifier_groups}
              otherDressingHandler={otherDressingHandler}
              selectedIngredients={selectedIngredients}
              handleIngredientSelection={handleSelection}
              setOtherDressingData={setOtherDressingData}
              isInItemPresent={isInItemPresent}
              sectionSelected={sectionSelected}
              noDressingHandler={noDressingHandler}
              isNoDressing={noDressing}
              selectedAddedIngredients={selectedAddedIngredients}
              noDressingModifiers={noDressingModifiers}
              label={label}
            />
          </>
        )}
        {!showProteinModalOnCombo && <hr />}
        {selectedItem?.category_id?.toString() === CONSTANT.REACT_APP_SALADS_ID &&
        !isShowingRequiredModalOnCustomization
          ? selectedItem && (
              <div className="px-md-5">
                <UpSellModifierGroup
                  coreModifiers={selectedItem?.core_modifiers}
                  handleIngredientSelection={(data: IModifiersObjects) => {
                    handleIngredientSelection(data);
                  }}
                  modifierGroups={selectedItem?.items_modifier_groups}
                  required_modifiers_groups={
                    selectedItem?.items_required_modifier_groups
                  }
                  category_name={selectedItem?.category_name}
                  category_id={selectedItem?.category_id}
                  isSaladFirstSelection={isSaladFirstSelection}
                  try2comboUpsellStyles={try2comboUpsellStyles}
                  HeadingStyles={true}
                />
              </div>
            )
          : null}
      </div>

      {!isItSubstitute() ? (
        <ApplyButton
          isDisabled={isApplyDisable}
          selectedOtherDressingData={selectedOtherDressingData}
          clickHandle={() => addItemtoCombo()}
          btnClass={`${styleClasses.large_btn}  mt-3`}
          label={buttonLabel()}
        />
      ) : null}
    </>
  );
};

export default Sliders;
